import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WfhService {
  public REST_API_SERVER:string = `${environment.REST_API_URL}/api/web/${environment.version}`;
  
  constructor(private http:HttpClient) { }

  public getWfh(filterParams:any={}):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/wfh/list`,{params:filterParams,observe:'response'});
  }

  public createWfh(data:any):Observable<any>{
    return this.http.post(`${this.REST_API_SERVER}/wfh/create-wfh`,data);
  }
  public updateWfhStatus(updatedRecord: any): Observable<any> {
    const url = '/api/wfh/update-status';  // Replace with your actual backend API endpoint
    return this.http.put(`${this.REST_API_SERVER}/wfh/update-status`, updatedRecord);
  }
}